import jQuery from 'jquery';

function addUrlParam(key, value) {
  try {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);

    searchParams.set(key, value);

    url.search = searchParams.toString();
    window.history.pushState({}, '', url);
  } catch (error) {
    throw new Error(`URL update error: ${error}`);
  }
}

function removeUrlParam(key) {
  const url = new URL(window.location.href);
  const searchParams = new URLSearchParams(url.search);

  searchParams.delete(key);

  url.search = searchParams.toString();
  window.history.pushState({}, '', url);
}

jQuery(function($) {
  const $faq = $('.faq');

  $faq.each(function() {
    const $questions = $faq.find('.faq__question-item');
    const $answersLists = $faq.find('.faq__answer-list');
    const $answersItems = $answersLists.find('.faq__answer-item');
    const $answersTitles = $answersItems.find('.faq__answer-title');
    const $answersText = $answersItems.find('.faq__answer-text');

    $answersTitles.append('<svg class="faq__answer-icon" width="28" height="28" viewBox="0 0 28 28" fill="none"' + ' xmlns="http://www.w3.org/2000/svg"><circle cx="14" cy="14" r="13" stroke="#002677" stroke-width="2"/><path d="M14 21L14 7" stroke="#002677" stroke-width="2" stroke-linejoin="round"/><path d="M7 14L21 14" stroke="#002677" stroke-width="2" stroke-linejoin="round"/></svg>');

    const lastTextBlock = $answersText.find('p:last-child');
    const shareButton = $('<span class="faq__answer-share"></span>');
    shareButton.append('<svg class="faq__answer-share-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M15.197 3.35462C16.8703 1.67483 19.4476 1.53865 20.9536 3.05046C22.4596 4.56228 22.3239 7.14956 20.6506 8.82935L18.2268 11.2626M10.0464 14C8.54044 12.4882 8.67609 9.90087 10.3494 8.22108L12.5 6.06212"stroke-width="1.5" stroke-linecap="round"/><path d="M13.9536 10C15.4596 11.5118 15.3239 14.0991 13.6506 15.7789L11.2268 18.2121L8.80299 20.6454C7.12969 22.3252 4.55237 22.4613 3.0464 20.9495C1.54043 19.4377 1.67609 16.8504 3.34939 15.1706L5.77323 12.7373" stroke-width="1.5" stroke-linecap="round"/></svg>');
    shareButton.append('<span class="faq__answer-share-text text text--small text--secondary2">Ссылка скопирована</span>');

    shareButton.on('click', function(e) {
      const $this = $(this);

      const $answerItem = $this.closest('.faq__answer-item');
      const $answerList = $this.closest('.faq__answer-list');

      const questionIndex = $answerList.data('answer');
      const answerIndex = $answerItem.data('answer');

      navigator.clipboard.writeText(window.location.origin + window.location.pathname + '?question=' + questionIndex + '&answer=' + answerIndex);

      $this.addClass('faq__answer-share--copied');

      setTimeout(() => {
        $this.removeClass('faq__answer-share--copied');
      }, 3000);
    });

    if (lastTextBlock) {
      lastTextBlock.append(shareButton);
    } else {
      $answersText.append(shareButton);
    }

    if (window.innerWidth < global.width_md) {
      $answersLists.each(function() {
        const $answerList = $(this);

        const $question = $questions.filter(function() {
          return $(this).data('question') === $answerList.data('answer');
        });

        $answerList.insertAfter($question);
      });
    }

    $questions.on('click', function() {
      const $question = $(this);
      const num = $question.data('question');
      const $answer = $answersLists.filter(function() {
        return $(this).data('answer') === num;
      });

      if (window.innerWidth < global.width_md) {
        $questions.not($question).removeClass('faq__question-item--active');
        $question.toggleClass('faq__question-item--active');

        $answersLists.not($answer).addClass('d-none');
        $answer.toggleClass('d-none');
      } else {
        $questions.removeClass('faq__question-item--active');
        $question.addClass('faq__question-item--active');

        $answersLists.addClass('d-none');
        $answer.removeClass('d-none');
      }

      addUrlParam('question', num);
      removeUrlParam('answer');
    });

    $answersTitles.on('click', function() {
      const $answerTitle = $(this);
      const $answerItem = $answerTitle.closest('.faq__answer-item');
      const $answerList = $answerTitle.closest('.faq__answer-list');
      const $answerText = $answerItem.find('.faq__answer-text');
      const isActive = $answerItem.hasClass('faq__answer-item--active');

      if (isActive) {
        $answerText.slideUp(200);

        removeUrlParam('answer');
      } else {
        $answerText.slideDown(200);

        addUrlParam('question', $answerList.data('answer'));
        addUrlParam('answer', $answerItem.data('answer'));
      }
      $answerItem.toggleClass('faq__answer-item--active', !isActive);
    });

    const params = new window.URLSearchParams(window.location.search);
    const questionId = params.get('question');
    const answerId = params.get('answer');

    if (questionId !== null) {
      const $question = $questions.filter(function() {
        return $(this).data('question') === parseInt(questionId, 10);
      });
      $questions.removeClass('faq__question-item--active');
      $question.addClass('faq__question-item--active');

      if (answerId !== null) {
        const $answerList = $answersLists.filter(function() {
          return $(this).data('answer') === parseInt(questionId, 10);
        });
        $answersLists.addClass('d-none');
        $answerList.removeClass('d-none');

        const $answerItem = $answersItems.filter(function() {
          return $(this).data('answer') === parseInt(answerId, 10);
        });
        $answerItem.addClass('faq__answer-item--active');
        const $answerText = $answerItem.find('.faq__answer-text');
        $answerText.slideDown(200);
      }

      $faq.get(0).scrollIntoView({ behavior: 'smooth' });
    }
  });
});
